import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';

import { useQltAuthStore } from '../stores/qlt';
import { Spinner } from '../components';
import { useSignOut } from './useSignOut';

export function AuthGate({ children }: { children: ReactNode }) {
  const { t } = useTranslation('login');
  const jwt = useQltAuthStore((state) => state.jwt);
  const isTeacher = useQltAuthStore((state) => state.isTeacher);
  const hydrating = useQltAuthStore((state) => state.hydrating);
  const signOut = useSignOut();
  const location = useLocation();
  if (hydrating) return <div className="auth-gate-state"><Spinner label={t('auth.restoring')} size="large" /></div>;
  if (!jwt) {
    return <Navigate to="/login" replace={true} state={{ from: location.pathname + location.search }} />;
  }
  if (!isTeacher) return <main className="auth-gate-state"><div><h1>{t('auth.notTeacherTitle')}</h1><p>{t('auth.notTeacherBody')}</p><button type="button" className="primary-button" onClick={signOut}>{t('auth.signInOther')}</button></div></main>;
  return <>{children}</>;
}

export default AuthGate;
